import { lazy } from "react";

// Its own chunk, so Tiptap and ProseMirror stay out of the main bundle.
export const LazyConversationTiptapInput = lazy(() =>
    import("#features/conversations/components/conversation-input/ConversationTiptapInput.tsx")
        .then(module => ({ default: module.ConversationTiptapInput }))
);

let preloading: Promise<unknown> | undefined;

// Starts the same chunk as soon as a page knows it will show the editor, so it downloads alongside the page's data rather
// than after it. A failed download is left to the lazy editor, whose error boundary asks for a reload.
export const preloadConversationTiptapInput = () => {
    preloading ??= import("#features/conversations/components/conversation-input/ConversationTiptapInput.tsx").catch(() => undefined);
};
